import React from 'react';
import Styles from './index.module.css';

export default function CarouselDoodle() {
  return (
    <div className={Styles.mainContainer}>
      <div className={Styles.doodleContainer} style={{ flex: 2 }} />
      <div className={Styles.doodleContainer} style={{ flex: 2 }} />
      <div className={Styles.doodleContainer} style={{ flex: 1 }} />
    </div>
  );
}
